// extracted by mini-css-extract-plugin
module.exports = {"header":"h2-QFJR2jEPbHAw5ZZRUu","dialog":"_3KypMZJS_2NwmqIkPahYSt"};